//* 布局属性
import type { ModulesNavigation } from "@/views/details/components/container/src";
//* 组件
import type ModuleComponent1 from "./components/module1/index.vue";
import type ModuleComponent2 from "./components/module2/index.vue";
import type ModuleComponent3 from "./components/module3/index.vue";
//* 样式
import css_father from "../../components/container/style/index.module.less";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();
    const route = useRoute();

    //* 节点
    const nodes = {
        module1: ref<InstanceType<typeof ModuleComponent1>>(),
        module2: ref<InstanceType<typeof ModuleComponent2>>(),
        module3: ref<InstanceType<typeof ModuleComponent3>>(),
    };

    //* 响应式变量
    const refs = {
        navigations: ref<ModulesNavigation[]>([
            { name: i18n.t("BasicInformation"), ref: nodes.module1, index: 1, visible: true },
            { name: i18n.t("Phenotypes", 2), ref: nodes.module2, index: 2, visible: true },
            { name: i18n.t("References"), ref: nodes.module3, index: 3, visible: true },
        ]),
    };

    //* 函数列表
    const methods = {
        register: (href: string, module: any, method: "POST" | "GET" = "GET") => {
            return api.frontend(href, {
                method: method,
                data: { id: route.params.id, mode: "model" },
                error: () => module?.hidden(),
                hidden: true,
                success: (response) => {
                    if (!response) module?.hidden();
                    else {
                        module?.render(response);
                    }
                },
            });
        },

        move: (node: any) => {
            if (node && node.$el) {
                scrollTo({
                    top: node.$el.offsetTop - 64 - ((document.querySelector(css_father.header) as HTMLDivElement)?.offsetHeight || 0),
                    behavior: "smooth",
                });
            }
        },
    };

    //* 计算属性
    const computeds = {
        options: computed(() => {
            return {
                cover: "https://rdgta.cdn.cyagen.com/rddc/pictures/2d909354-20ad-48bf-88dc-7201b8266ae7.webp",
                navigations: refs.navigations.value,
            };
        }),
    };

    return { refs, nodes, methods, computeds };
};
